import { gql } from '@apollo/client';
import { ARCHIVE_FIELDS, CONSENTS_GROUP_FIELDS, LINK_FIELDS, PERSON_FIELDS } from "./core";
import { EMBEBED_TREE_MAP_FIELDS } from "./tree";
export const PARTICIPANT_FIELDS = gql`
  ${PERSON_FIELDS}
  fragment ParticipantFields on ParticipantDto {
    id
    templateCode
    templateName
    acceptElectronicSignature
    person {
      ...PersonFields
    }
  }
`;
export const PARTICIPANT_TEMPLATE_FIELDS = gql`
  fragment ParticipantTemplateFields on ParticipantTemplateDto {
    id
    code
    name
    maxParticipants
    personType
    minimumAge
    sign
  }
`;
export const HOSPITALIZATION_FIELDS = gql`
  fragment HospitalizationFields on HospitalizationDto {
    admissionDate
    serviceCode
    hospitalId
    sillonsId
    preAdmissionId
    importGamDate
    exportGamDate
    establishmentName
    establishmentService
    exitDate
    flagDocumentsProcessed
    flagDossierWritten
    companyStructure {
      id
      name
      structure
    }
  }
`;

// TODO forma de parametrizar esto mejor etc ?

export const DOSSIER_FIELDS = gql`
  ${PARTICIPANT_FIELDS}
  ${ARCHIVE_FIELDS}
  ${LINK_FIELDS}
  ${CONSENTS_GROUP_FIELDS}
  fragment DossierFields on DossierDto {
    id
    name
    remarks
    businessUnitId
    businessUnitName
    businessUnitCodename
    treeWorkflow
    callbackUrl
    redirectUrl
    statusTreeLevel1
    statusTreeLevel2
    statusTreeLevel3
    statusTreeLevel4
    timestamp
    creationTimestamp
    createdBy
    modifiedBy
    participants {
      ...ParticipantFields
    }
    archives {
      ...ArchiveFields
    }
    links {
      ...LinkFields
    }
    consentsGroup {
      ...ConsentsGroupFields
    }
  }
`;
export const DOSSIER_FIELDS_W_HOSPITALIZATION = gql`
  ${HOSPITALIZATION_FIELDS}
  ${DOSSIER_FIELDS}
  fragment DossierFieldsWHospitalization on DossierDto {
    ...DossierFields
    hospitalization {
      ...HospitalizationFields
    }
  }
`;
export const DOSSIER_FIELDS_W_WORKFLOW_TREE = gql`
  ${DOSSIER_FIELDS}
  ${EMBEBED_TREE_MAP_FIELDS}
  fragment DossierFieldsWWorkflowTree on DossierDto {
    ...DossierFields
    treeWorkFlowMap {
      ...EmbebedTreeMapFields
    }
  }
`;
export const DOSSIER_FIELDS_W_TYPE_TREE = gql`
  ${DOSSIER_FIELDS}
  ${EMBEBED_TREE_MAP_FIELDS}
  fragment DossierFieldsWTypeTree on DossierDto {
    ...DossierFields
    treeTypeMap {
      ...EmbebedTreeMapFields
    }
  }
`;
export const DOSSIER_FIELDS_W_TREES = gql`
  ${DOSSIER_FIELDS}
  ${EMBEBED_TREE_MAP_FIELDS}
  fragment DossierFieldsWTrees on DossierDto {
    ...DossierFields
    treeWorkFlowMap {
      ...EmbebedTreeMapFields
    }
    treeTypeMap {
      ...EmbebedTreeMapFields
    }
  }
`;
export const DOSSIER_FIELDS_W_HOSPITALIZATION_TREES = gql`
  ${DOSSIER_FIELDS_W_HOSPITALIZATION}
  ${EMBEBED_TREE_MAP_FIELDS}
  fragment DossierFieldsWHospitalizationTrees on DossierDto {
    ...DossierFieldsWHospitalization
    treeWorkFlowMap {
      ...EmbebedTreeMapFields
    }
    treeTypeMap {
      ...EmbebedTreeMapFields
    }
  }
`;
export const DOSSIER_TEMPLATE_FIELDS = gql`
  ${PARTICIPANT_TEMPLATE_FIELDS}
  fragment DossierTemplateFields on DossierTemplateDto {
    id
    creationTimestamp
    timestamp
    name
    code
    config
    workflowTreeCode
    businessUnitName
    businessUnitId
    workflowTreeCodeBusinessUnitId
    participantTemplates {
      ...ParticipantTemplateFields
    }
  }
`;